const { useSelector } = require('react-redux');

const usePreviousSubscriptionFamily = () => {
  const previousSubscriptionId = useSelector(state => state.subscriptions?.previousSubscriptionIdForDeactivatedUser);
  const subscriptionDetails = useSelector(state => state.subscriptions?.data);

  // Guard: only access subscriptionDetails if it exists
  const userPreviousSubscriptionData = subscriptionDetails ? subscriptionDetails[previousSubscriptionId] : undefined;

  return {
    userPreviousSubscriptionFamily: userPreviousSubscriptionData?.family,
    isActiveUser: !previousSubscriptionId,
  };
};

export default usePreviousSubscriptionFamily;
